import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { FaFrownOpen } from "react-icons/fa";
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
// import { useLocation } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";


export default function Booking() {
    let [data, setData] = useState([])
    let { _id } = useParams()
// let location = useLocation();
    // let navigate = useNavigate()
    // async function deleteData(_id) {
    //     if (window.confirm("Are You Sure to Delete that Item :")) {
    //         let response = await fetch(`http://34.228.14.188:8000/api/booking/` + _id, {
    //             method: "DELETE",
    //             headers: {
    //                 "content-type": "application/json"
    //             },
    //         body: JSON.stringify({...data})
    //         })


    //         response = await response.json()
    //         if (response.length) {
    //             toast.success("Deleted SuccessFully")
    //             getApiData()
    //             setData(response)
    //         }
    //     }
    // }

    async function deleteData(_id) {
   if(window.confirm("Are You Sure to Delete that Item :")){
    
    let response = await fetch(`http://34.228.14.188:8000/api/booking/`+ _id,{
        method:"DELETE",
        headers:{
            "content-type" : "application/json"
        },
        // body: JSON.stringify({...data})
    })
    response = await response.json()
    
    if(response.result==="Done"){
        toast.success("Deleted SuccessFully")
        setData(response)
    }
   }
}

    async function getApiData() {
        let response = await fetch("http://34.228.14.188:8000/api/booking", {
            method: "GET",
            headers: {
                "content-type": "application/json",
                // "authorization":localStorage.getItem("token")
            }
        })

        let data = await response.json(); // Response JSON alag variable mein

        if (data.result === "Done") {

            // 🔥 Filter data: remove where paymentStatus = "pending" AND paymentMode = "Net Banking"
            const filteredData = data.data.filter(item => {
                return !(item.paymentStatus?.toLowerCase().trim() === "pending" && item.paymentMode?.toLowerCase().trim() === "net banking");
                // return !(item.paymentStatus === "pending" && item.paymentMode === "Net Banking");
            });
            //  console.log(item.paymentStatus,item.paymentMode);

            console.log(filteredData); // just for checking
            setData(filteredData); // ✅ Set only filtered data
        } else {
            setData([]);
        }
    }

    // function showCheckout(_id) {
    //     if (_id)
    //         navigate(`/admin/${_id}`)
    // }


    useEffect(() => {
        getApiData()
    }, [])
    return (
        <>
            <UserHero />
            <div className="container">
                <div className="row my-3">

                    <ListGroup />

                    <div className="col-md-8">
                        <h1 className=' testimonials-h1 text-light text-center p-2' style={{ background: "#" }}>Booking Table </h1>
                        <div className="table-responsive">
                            {
                                data.length ?

                                    <table className='table table-bordered responsive'>
                                        <thead>
                                            <tr>
                                                <th>id</th>
                                                <th>check In Date</th>
                                                <th>check out Date</th>
                                                <th>adult</th>
                                                <th>child</th>
                                                  <th>Price/Night</th>
                                                  <th>No. of Night</th>
                                                <th>Total Room</th>
                                                <th>Total</th>
                                                <th>Payment Status</th>
                                                <th>Transection Id</th>
                                                <th>Payment Mode</th>
                                                <th>Date</th>
                                                {/* <th>Show</th> */}
                                                <th>delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td>
                                                            {item._id}</td>
                                                        <td>{item.checkIn}</td>
                                                        <td>{item.checkOut}</td>
                                                        <td>{item.adult}</td>
                                                        <td>{item.child}</td>
                                                        <td>{item.price}</td>
                                                        <td>{item.days}</td>
                                                        <td>{item.qty}</td>
                                                        <td>{item.total}</td>
                                                        <td>{item.paymentStatus}</td>
                                                        <td>{item.rppid}</td>
                                                        <td>{item.paymentMode}</td>
                                                        <td>{new Date(item.date).toLocaleDateString('en-GB')}</td>
                                                        {/* <td style={{ width: "50px" }}>
                                                            <button className="btn btn-danger" onClick={() => showCheckout(item._id)}>
                                                                <FaEye />
                                                            </button>
                                                        </td> */}


                                                        <td>
                                                            <td>
                                                                                             
                                                                                              <MdDeleteForever className='testimonil-table-btn' style={{height:"30", width:"50", }} onClick={() => deleteData(item._id)} />
                                                                                          
                                                                                              </td>
                                                        </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="not-testinomonil">
                                        <h3>Sorry! <FaFrownOpen />  User Booking Record Not Found!!</h3>

                                    </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
